<template>
  <div
    v-if="screenWidth > 1024"
    class="nko-detail-menu"
  >
    <a
      href="javascript: void(0)"
      class="nko-detail-menu__item nko-detail-menu__item_active"
    >
      Личные данные
    </a>
    <a
      href="javascript: void(0)"
      class="nko-detail-menu__item"
    >
      Мои проекты
    </a>
    <a
      href="javascript: void(0)"
      class="nko-detail-menu__item"
    >
      Отзывы
    </a>
    <a
      href="javascript: void(0)"
      class="nko-detail-menu__item"
    >
      Сообщения
    </a>
  </div>
  <!--    static-label-->
  <!--    v-model="currentPage"-->
  <div
    v-else
    class="nko-detail-menu-mobile"
  >
    <ASelect
      label=""
      name="categories"
      display="title"
      value="url"
      hideSelected
      :options="[
        {value: 'option1code', title: 'Личные данные'},
        {value: 'option2code', title: 'Мои проекты'},
        {value: 'option3code', title: 'Отзывы'},
        {value: 'option4code', title: 'Сообщения'},
      ]"
    >
      <template #item="item">
        <div class="flex v-center">
          <a :href="item.url" class="nko-detail-menu-mobile__item">{{ item.title }}</a>
        </div>
      </template>
    </ASelect>
  </div>

</template>

<script>
import { ASelect } from "../ui";

export default {
  name: 'NkoDetailMenu',
  props: ['result'],
  components: {
    ASelect,
  }
}
</script>

<style lang="scss" scoped>
.nko-detail-menu {
  display: grid;
  grid-auto-rows: 60px;
  background: #FFFFFF;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  margin-top: 238px;
  //@include tablet{
  //  margin-top: 0;
  //  order: 1;
  //}
  &__item{
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    &:not(:last-child){
      border-bottom: 1px solid #E9EBED;
    }
    &_active{
      background: #D8DCDE;
    }
  }
}
.nko-detail-menu-mobile{
  @include tablet{
    margin-top: 0;
    order: 1;
  }
  @include mobile{

  }
  &__item{
    color: #000;
  }
}
</style>